import React, { useState } from "react";
import { bytesToSize } from "../../../core/bytesToSize";
import OutsideClickHandler from "react-outside-click-handler";
import { Icon } from "../../../core/Icon";
import { AppConfig } from "../../../app-state";
export const FormFileItem = (props) => {
    const [dropdownOpen, setDropdown] = useState(false);
    const dropdownHtml = (item) => {
        return React.createElement(OutsideClickHandler, { onOutsideClick: () => setDropdown(false) },
            React.createElement("button", { type: "button", className: "trigger", onClick: () => setDropdown(!dropdownOpen), "aria-expanded": dropdownOpen },
                React.createElement(Icon, { c: ['dots', 14, 14] })),
            dropdownOpen &&
                React.createElement("div", { className: "list" },
                    React.createElement("button", { type: "button", className: "item", onClick: () => { setDropdown(false); props.removeItem(item.id); } }, "Odebrat"),
                    props.allowMainImage &&
                        React.createElement("button", { type: "button", className: "item", onClick: () => { setDropdown(false); props.setMainImage(item.id); } }, "Nastavit jako hlavn\u00ED obr\u00E1zek")));
    };
    let bgSource = props.item.thumbData ? props.item.thumbData : AppConfig.filesPrefix + props.item.path_thumb;
    return props.item.type == 'image' ? (React.createElement("div", { className: "item-row" },
        React.createElement("div", { className: "name" }, props.item.name || props.item.filename),
        React.createElement("div", { className: "desc" },
            props.item.status !== 'removal' && React.createElement("span", { className: "size" },
                "Velikost: ",
                bytesToSize(props.item.size)),
            props.index == props.mainImage && React.createElement("span", { className: "main" }, "Hlavn\u00ED obr\u00E1zek"),
            props.item.status == 'removal' && React.createElement("span", { className: "removal" }, "Ozna\u010Deno k odstran\u011Bn\u00ED")),
        React.createElement("div", { className: "thumb-image", style: { backgroundImage: 'url(' + bgSource + ')' } }),
        React.createElement("div", { className: "dots-dropdown" }, dropdownHtml(props.item)))) : (React.createElement("div", { className: "item-row" },
        React.createElement("div", { className: "name" }, props.item.name || props.item.filename),
        React.createElement("div", { className: "desc" },
            props.item.status !== 'removal' && React.createElement("span", { className: "size" },
                "Velikost: ",
                bytesToSize(props.item.size)),
            props.index == props.mainImage && React.createElement("span", { className: "main" }, "Hlavn\u00ED obr\u00E1zek"),
            props.item.status == 'removal' && React.createElement("span", { className: "removal" }, "Ozna\u010Deno k odstran\u011Bn\u00ED")),
        React.createElement(Icon, { c: ['pdf', 32, 32, 'thumb-file'] }),
        React.createElement("div", { className: "dots-dropdown" }, dropdownHtml(props.item))));
};
